<template>
	<div style="height: 84vh;">
		<div class="tenant_search">
			<div class="tenant_search_1">
				<i class="ione"></i>
				<el-input placeholder="请输入房间编号" prefix-icon="el-icon-search" v-model="data.room_num"
					@keyup.enter.native="search()" @change="handleStatusChange"></el-input>
			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-input placeholder="请输入订单号" prefix-icon="el-icon-search" v-model="data.number" @keyup.enter.native="search()"
					@change="handleStatusChange"></el-input>
			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-input placeholder="请输入姓名或手机" prefix-icon="el-icon-search" v-model="data.np" @keyup.enter.native="search()"
					@change="handleStatusChange"></el-input>
			</div>
			<!-- <div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-select v-model="data.pay_status" placeholder="订单状态" @change="handleStatusChange">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div> -->
			<!-- 		<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-select v-model="data.type" placeholder="订单类型" @change="handleStatusChange">
					<el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div> -->
			<div class="tenant_search_1 searctime" v-show="launched">
				<i></i>
				<el-date-picker style="width: 100%;" v-model="data.start_time" type="date" placeholder="开始日期"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div class="tenant_search_1 searctime" v-show="launched">
				<i></i>
				<el-date-picker style="width: 100%;" v-model="data.end_time" type="date" placeholder="结束日期"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>



			<div style="display: flex;justify-content: space-between;width: 100%;align-items: center;"
				:style="{ marginLeft: minw ? '1rem' : '0' ,marginRight: minw ? '1rem' : '0'}">
				<div>
					<button class="search_button" @click="search()">搜索</button>
					<button class="search_button" @click="search('重置')">重置</button>
				</div>
				<div v-show="minw" style="display: flex;align-items: center;">
					<p style="color: #909399;">{{launched?'收起':'展开'}}</p>
					<i size="mini" :class="launched?'el-icon-arrow-up':'el-icon-arrow-down'" @click="launched=!launched"></i>
				</div>

			</div>
		</div>
		<ListingButton :lists="lists" @add='add'></ListingButton>
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			@BannerStatus='BannerStatus' style="margin: 1rem;"></MyTable>
		<MyDialog :item="EditValue" :DialogTitle="DialogTitle" @changedia="changedia"
			:centerDialogVisible="centerDialogVisible"></MyDialog>
		<Mycell :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BannerStatus='BannerStatus' @BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete"
			@Currentchange="contractlistcontractlist" style="padding-bottom: 4rem;"></Mycell>
	</div>
</template>

<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import MyDialog from "@/components/My_dialog/index.vue"
	import {
		bill_info,
		bill_delete,
		send_msg,
		back_pay
	} from "@/api/api.js"
	import Mycell from "@/components/My_cell/index.vue"
	export default {
		data() {
			return {
				name: 'orders',
				lists: [{
					name: '生成订单',
					type: 'primary',
					funt: 'add'
				}],
				tableData: [],
				table_label: [{
					label: '订单号',
					value: 'number'
				}, {
					label: '订单类型',
					value: 'type'
				}, {
					label: '用户姓名',
					value: 'user_name'
				}, {
					label: '房间编号',
					value: 'room_num'
				}, {
					label: '金额',
					value: 'money'
				}, {
					label: '开始时间',
					value: 'start_time'
				}, {
					label: '结束时间',
					value: 'end_time'
				}, {
					label: '订单状态',
					value: 'pay_status'
				}, {
					label: '支付类型',
					value: 'pay_type'
				}, {
					label: '支付时间',
					value: 'pay_time'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 15,
					pay_status: 0,
					np: '',
					number: '',
					room_num: '',
					start_time: '',
					end_time: '',
					type: ''
				},
				options: [{
					value: 0,
					label: '待支付'
				}, {
					value: 1,
					label: '已支付'
				}, ],
				options2: [{
					value: 1,
					label: '水费'
				}, {
					value: 2,
					label: '电费'
				}, {
					value: 3,
					label: '房租'
				}, {
					value: 4,
					label: '押金差额'
				}, ],
				minw: JSON.parse(sessionStorage.getItem('minw')),
				launched: !JSON.parse(sessionStorage.getItem('minw'))
			}
		},
		methods: {
			search(resetting) {

				if (resetting != undefined) {

					this.data.pay_status = 0
					this.data.np = ''
					this.data.number = ''
					this.data.room_num = ''
					this.data.start_time = ''
					this.data.end_time = ''
					this.data.type = ''
					this.contractlistcontractlist(this.data.page)
				} else {
					sessionStorage.setItem(this.$router.currentRoute.path + 'search_status', 1);

					this.contractlistcontractlist('搜索')
				}
			},
			handleStatusChange() {
				sessionStorage.setItem(this.$router.currentRoute.path + 'search_status', 0);
			},
			contractlistcontractlist(value) {
				if (value == '搜索') {
					this.data.page = 1
				} else if (sessionStorage.getItem(this.$router.currentRoute.path + 'search_status') == 1) {
					this.data.page = value ? value : this.data.page
				} else {
					this.data = {
						page: value ? value : this.data.page,
						limit: 15,
						pay_status: 0,
					}
				}
				bill_info(this.data).then(res => {
					console.log('res', res);
					if (res.status == 200) {
						this.tableData = res.data.list
						this.total = res.data.count
						if (res.__requestPayload) {
							this.data = res.__requestPayload
						}
					}
				})
			},
			add() {
				this.centerDialogVisible = true
				this.DialogTitle = '生成订单'
			},
			//点击编辑
			Edit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '订单编辑'
			},
			// 批量删除的数组
			DeleteValue(value) {
				this.multipleSelection = value
			},
			// 批量删除的方法
			BatchDelete() {
				bill_delete({
					ids: this.multipleSelection
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
				console.log(111);
			},
			// 点击删除
			Delete(value) {
				console.log("Delete", value.id);
				bill_delete({
					ids: [`${value.id}`]
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			async BannerStatus(value, name) {
				console.log(name);
				if (name == '后台支付') {
					const res = await back_pay(value.id)
					this.Messages(res)
					this.contractlistcontractlist()
				} else {

					const res = await send_msg({
						id: value.id
					})
					this.Messages(res)
					this.contractlistcontractlist()
				}

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			changedia(value) {
				this.centerDialogVisible = value
			},
		},
		components: {
			MyTable,
			ListingButton,
			MyDialog,
			Mycell
		},
		created() {
			console.log('用户ID:', this.$route.query.status);
			this.contractlistcontractlist()
		},
	}
</script>

<style scoped>
	.tenant_search {
		display: flex;
		align-items: center;
		background-color: var(--cont_backgound);
		margin: 1.25rem;
		padding: 10px;
		border-radius: 8px;
	}

	::v-deep .el-input__inner:focus {
		border: 1px solid #3C46FF;
	}

	.tenant_search_1 {
		display: flex;
		align-items: center;

	}

	.tenant_search_1 span {
		width: 2.6rem;

	}

	.tenant_search .tenant_search_1:first-child i {
		margin-left: 0rem;
	}

	.tenant_search_1 i {
		height: 1.25rem;
		width: 0.375rem;
		background-color: #3C46FF;
		border-radius: 0.625rem;
		margin: 0 0.625rem;
		margin-left: 1rem;
	}

	.tenant_search :nth-child(2) span {
		width: 4.8rem;
	}


	.tenant_search_1 .el-input {
		width: 9rem;
	}

	.search_button {
		font-size: 0.85rem;
		height: 2rem;
		width: 5rem;
		margin: 0 0.625rem;
		background-color: #409eff;
		border: #409eff;
		color: #fff;
		border-radius: 6px;
	}

	.search_button:hover {
		opacity: 0.8;
	}

	.tenant_search .tenant_search_1 {
		flex: 1 1 auto !important;
		min-width: 11rem !important;
	}



	.tenant_search .tenant_search_1:nth-of-type(4),
	.tenant_search .tenant_search_1:nth-of-type(5) {
		min-width: 12.4rem !important;
	}

	.tenant_search_1 .el-select {
		width: 100% !important;
	}
</style>
<style>
	.searctime {
		width: 12.4rem !important;
	}
</style>